import { ReactElement } from 'react';

import { Tooltip } from '@cast/design-system';
import { ComputeResourceType } from '@cast/shared-types';

import { computeResourceWordMap } from 'constants/maps';

type Props = {
  unit: ComputeResourceType;
  wrapIf?: boolean;
  children: ReactElement;
};

export const OptimizationNotEnabledTooltip = ({
  unit,
  wrapIf,
  children,
}: Props) => {
  return (
    <Tooltip
      title={`This recommendation won't be applied because ${computeResourceWordMap[unit]} optimization is disabled.`}
      wrapIf={wrapIf}
    >
      {children}
    </Tooltip>
  );
};
